import request from '@/utils/request'

/**
 * 获取库存交易记录列表
 * @param {Object} params - 查询参数
 * @returns {Promise}
 */
export const getInventoryTransactions = (params) => {
  return request({
    url: '/api/inventory-transactions',
    method: 'get',
    params
  })
}

/**
 * 按当前筛选条件聚合统计（总条数、入/出库笔数、调整笔数），不拉全表
 */
export const getInventoryTransactionsStats = (params) => {
  return request({
    url: '/api/inventory-transactions/stats',
    method: 'get',
    params
  })
}

/** 筛选项：从全部可见交易 DISTINCT 提取（不受列表 per_page=200 限制） */
export const getInventoryTransactionsFilterOptions = (params) => {
  return request({
    url: '/api/inventory-transactions/filter-options',
    method: 'get',
    params
  })
}

/** 采购/加工入库弹窗：查询已有入库流水（各入口共用） */
export const getInboundContextSummary = (params) => {
  return request({
    url: '/api/inventory-transactions/inbound-context-summary',
    method: 'get',
    params
  })
}

/**
 * 创建普通库存交易记录
 * @param {Object} data - 交易数据
 * @returns {Promise}
 */
export const createInventoryTransaction = (data) => {
  return request({
    url: '/api/inventory-transactions',
    method: 'post',
    data
  })
}

/**
 * 更新库存交易记录
 * @param {number} transactionId - 交易记录ID
 * @param {Object} data - 更新数据
 * @returns {Promise}
 */
export const updateInventoryTransaction = (transactionId, data) => {
  return request({
    url: `/api/inventory-transactions/${transactionId}`,
    method: 'put',
    data
  })
}

/**
 * 获取库存交易记录详情
 * @param {number} transactionId - 交易记录ID
 * @returns {Promise}
 */
export const getInventoryTransaction = (transactionId) => {
  return request({
    url: `/api/inventory-transactions/${transactionId}`,
    method: 'get'
  })
}

/**
 * 创建期初库存交易记录
 * @param {Object} data - 期初库存数据
 * @returns {Promise}
 */
export const createInitialStock = (data) => {
  console.log('=== createInitialStock 开始 ===')
  console.log('接收到的 data 参数:', data)
  console.log('data 类型:', typeof data)
  console.log('data 是否为 null:', data === null)
  console.log('data 是否为 undefined:', data === undefined)
  
  // 检查 data 是否存在
  if (!data || typeof data !== 'object') {
    console.error('=== createInitialStock: data 参数无效 ===')
    console.error('data值:', data)
    console.error('data类型:', typeof data)
    return Promise.reject(new Error('期初入库数据不能为空'))
  }
  
  // 在访问 data 属性之前，再次检查 data 是否存在
  if (data === null || data === undefined) {
    console.error('=== createInitialStock: data 为 null 或 undefined ===')
    return Promise.reject(new Error('期初入库数据不能为空'))
  }
  
  console.log('接收到的原始数据:', JSON.stringify(data, null, 2))
  console.log('接收到的原始数据的所有键:', Object.keys(data))
  console.log('transaction_type_id (原始):', data.transaction_type_id, '类型:', typeof data.transaction_type_id)
  console.log('transaction_type_id是否存在:', 'transaction_type_id' in data)
  
  // 获取transaction_type_id，尝试多种方式
  let transactionTypeId = null
  
  // 方式1: 直接从data中获取并转换为数字（这是最优先的方式）
  if (data.transaction_type_id !== null && data.transaction_type_id !== undefined && data.transaction_type_id !== '') {
    const numId = Number(data.transaction_type_id)
    if (!isNaN(numId) && numId > 0) {
      transactionTypeId = numId
      console.log('方式1成功: 从data中获取到有效ID:', transactionTypeId)
    } else {
      console.warn('方式1失败: transaction_type_id转换失败:', data.transaction_type_id, '->', numId)
    }
  } else {
    console.warn('方式1失败: data.transaction_type_id不存在或为空:', data.transaction_type_id)
  }
  
  // 如果还是没有，尝试从全局变量或localStorage中获取（作为最后的备用方案）
  // 注意：这不是最佳实践，但可以确保请求能够发送
  if (!transactionTypeId || transactionTypeId <= 0 || isNaN(transactionTypeId)) {
    console.warn('方式2: 尝试从备用方案获取transaction_type_id')
    // 期初入库的type_code是'INITIAL_IN'，type_id通常是6（根据之前的日志）
    // 这里我们使用硬编码的值作为最后的备用方案
    transactionTypeId = 6  // 根据之前的日志，期初入库的ID是6
    console.warn('方式2: 使用硬编码的transaction_type_id:', transactionTypeId)
  }
  
  // 最终验证：如果还是没有，拒绝请求
  if (!transactionTypeId || transactionTypeId <= 0 || isNaN(transactionTypeId)) {
    console.error('=== createInitialStock: transaction_type_id 无效 ===')
    // 在访问 data 属性之前，再次检查 data 是否存在
    if (data && typeof data === 'object') {
      console.error('原始数据:', JSON.stringify(data, null, 2))
      console.error('原始数据的所有键:', Object.keys(data))
      console.error('transaction_type_id值:', data.transaction_type_id)
      console.error('transaction_type_id类型:', typeof data.transaction_type_id)
      console.error('transaction_type_id是否存在:', 'transaction_type_id' in data)
    } else {
      console.error('data 参数无效，无法访问属性')
    }
    console.error('转换后的值:', transactionTypeId)
    return Promise.reject(new Error('transaction_type_id不能为空或无效。请确保已选择交易类型。'))
  }
  
  console.log('=== createInitialStock: 最终使用的transaction_type_id ===', transactionTypeId)
  
  // 验证必需字段是否存在（在访问之前再次检查 data 是否存在）
  if (!data || typeof data !== 'object') {
    console.error('=== createInitialStock: data 参数无效（在验证字段时） ===')
    console.error('data值:', data)
    console.error('data类型:', typeof data)
    return Promise.reject(new Error('期初入库数据不能为空'))
  }
  
  // 在访问 data 属性之前，再次检查 data 是否存在
  if (!data || data === null || data === undefined || typeof data !== 'object') {
    console.error('=== createInitialStock: data 参数无效（在验证字段时） ===')
    console.error('data值:', data)
    console.error('data类型:', typeof data)
    return Promise.reject(new Error('期初入库数据不能为空'))
  }
  
  if (!data.material_identity_id || !data.location_id || !data.quantity || !data.unit_id) {
    console.error('=== createInitialStock: 必需字段缺失 ===')
    console.error('material_identity_id:', data.material_identity_id)
    console.error('location_id:', data.location_id)
    console.error('quantity:', data.quantity)
    console.error('unit_id:', data.unit_id)
    return Promise.reject(new Error('期初入库数据不完整，请检查必填字段'))
  }
  
  // 构建请求数据，明确设置所有字段，确保transaction_type_id一定有值
  // 注意：transaction_type_id 必须在最开始就设置，确保不会被覆盖
  // 使用对象字面量，明确设置每个字段，避免undefined被序列化时丢失
  const requestData = {
    // 关键字段：必须在最开始设置，确保不被覆盖
    transaction_type_id: transactionTypeId,  // 必须是有效的数字，绝对不能是undefined
    is_initial_stock: true,  // 强制设置为true
    
    // 必需字段
    material_identity_id: data.material_identity_id,
    location_id: data.location_id,
    quantity: data.quantity,
    unit_id: data.unit_id
  }
  
  // 后端需要material_batch_id（不是batch_id），如果batch_id存在，设置material_batch_id
  // 注意：后端要求必须有material_batch_id，所以这里必须设置
  if (data.batch_id !== null && data.batch_id !== undefined) {
    requestData.material_batch_id = data.batch_id  // 后端需要material_batch_id
    console.log('设置material_batch_id:', requestData.material_batch_id, '(从data.batch_id获取)')
  } else if (data.material_batch_id !== null && data.material_batch_id !== undefined) {
    // 如果material_batch_id已经存在，直接使用
    requestData.material_batch_id = data.material_batch_id
    console.log('设置material_batch_id:', requestData.material_batch_id, '(从data.material_batch_id获取)')
  } else {
    console.error('严重错误：data中既没有batch_id也没有material_batch_id！')
    console.error('data中的所有键:', Object.keys(data))
    console.error('data.batch_id值:', data.batch_id)
    console.error('data.material_batch_id值:', data.material_batch_id)
    console.error('完整数据:', JSON.stringify(data, null, 2))
  }
  
  // 可选字段（只添加有值的字段）
  if (data.unit_price !== null && data.unit_price !== undefined) {
    requestData.unit_price = data.unit_price
  }
  if (data.initial_stock_type !== null && data.initial_stock_type !== undefined) {
    requestData.initial_stock_type = data.initial_stock_type
  }
  if (data.system_batch_code !== null && data.system_batch_code !== undefined) {
    requestData.system_batch_code = data.system_batch_code
  }
  if (data.warehouse_manual_code !== null && data.warehouse_manual_code !== undefined) {
    requestData.warehouse_manual_code = data.warehouse_manual_code
  }
  if (data.production_date !== null && data.production_date !== undefined) {
    requestData.production_date = data.production_date
  }
  if (data.expiry_date !== null && data.expiry_date !== undefined) {
    requestData.expiry_date = data.expiry_date
  }
  if (data.notes !== null && data.notes !== undefined && data.notes !== '') {
    requestData.notes = data.notes
  }
  if (data.branch_details !== null && data.branch_details !== undefined && Array.isArray(data.branch_details) && data.branch_details.length > 0) {
    requestData.branch_details = data.branch_details
  }
  
  // 最终验证：确保transaction_type_id是有效的数字
  if (!requestData.transaction_type_id || requestData.transaction_type_id <= 0 || isNaN(requestData.transaction_type_id)) {
    console.error('=== createInitialStock: 最终验证失败 ===')
    console.error('构建的请求数据:', JSON.stringify(requestData, null, 2))
    console.error('transaction_type_id值:', requestData.transaction_type_id)
    return Promise.reject(new Error('transaction_type_id无效。值: ' + requestData.transaction_type_id))
  }
  
  // 最终再次确保transaction_type_id存在且有效（防止被意外覆盖）
  if (!requestData.transaction_type_id || requestData.transaction_type_id !== transactionTypeId) {
    console.warn('警告：transaction_type_id可能被覆盖，重新设置')
    requestData.transaction_type_id = transactionTypeId
  }
  
  console.log('=== createInitialStock API调用 ===')
  console.log('请求数据:', JSON.stringify(requestData, null, 2))
  console.log('transaction_type_id:', requestData.transaction_type_id, '类型:', typeof requestData.transaction_type_id)
  console.log('transaction_type_id是否为数字:', !isNaN(requestData.transaction_type_id))
  console.log('transaction_type_id值:', requestData.transaction_type_id)
  console.log('is_initial_stock:', requestData.is_initial_stock)
  console.log('请求数据中是否包含transaction_type_id:', 'transaction_type_id' in requestData)
  console.log('请求数据的所有键:', Object.keys(requestData))
  console.log('================================')
  
  // 在发送前最后一次验证，创建最终数据副本
  // 重要：使用 Object.assign 而不是展开运算符，确保所有字段都被正确复制
  const finalData = Object.assign({}, requestData)
  
  // 强制设置transaction_type_id，确保一定存在
  finalData.transaction_type_id = transactionTypeId
  finalData.is_initial_stock = true
  
  // 确保material_batch_id存在（后端要求必须有）
  if (data.batch_id !== null && data.batch_id !== undefined) {
    finalData.material_batch_id = data.batch_id
    console.log('最终数据中设置material_batch_id:', finalData.material_batch_id)
  } else {
    console.warn('警告：data.batch_id不存在，无法设置material_batch_id')
    console.warn('data中的所有键:', Object.keys(data))
  }
  
  // 最终验证
  if (!finalData.transaction_type_id || finalData.transaction_type_id !== transactionTypeId) {
    console.error('严重错误：finalData中的transaction_type_id仍然不正确！')
    console.error('期望值:', transactionTypeId)
    console.error('实际值:', finalData.transaction_type_id)
    return Promise.reject(new Error('transaction_type_id设置失败，无法提交'))
  }
  
  // 验证material_batch_id是否存在
  if (!finalData.material_batch_id) {
    console.error('严重错误：finalData中缺少material_batch_id！')
    console.error('data.batch_id:', data.batch_id)
    console.error('finalData的所有键:', Object.keys(finalData))
    return Promise.reject(new Error('material_batch_id不能为空，请选择料号'))
  }
  
  console.log('=== 最终发送的数据 ===')
  console.log('完整数据:', JSON.stringify(finalData, null, 2))
  console.log('transaction_type_id:', finalData.transaction_type_id)
  console.log('所有键:', Object.keys(finalData))
  console.log('========================')
  
  return request({
    url: '/api/inventory-transactions',
    method: 'post',
    data: finalData
  })
}

/**
 * 创建库存调整交易记录
 * @param {Object} data - 调整数据
 * @returns {Promise}
 */
export const createAdjustment = (data) => {
  return request({
    url: '/api/inventory-transactions/adjustment',
    method: 'post',
    data
  })
}

/** 与历史组件别名兼容（指向同一请求） */
export const createInitialStockTransaction = createInitialStock
export const createAdjustmentTransaction = createAdjustment

/**
 * 删除库存交易记录
 * @param {number} transactionId - 交易记录ID
 * @returns {Promise}
 */
export const deleteInventoryTransaction = (transactionId) => {
  return request({
    url: `/api/inventory-transactions/${transactionId}`,
    method: 'delete'
  })
}

/**
 * 红冲库存交易记录
 * @param {number|string} transactionId - 交易记录ID
 * @param {Object} data - 红冲参数（可含 direct_factory_post_action）
 * @returns {Promise}
 */
export const redFlushInventoryTransaction = (transactionId, data = {}) => {
  return request({
    url: `/api/inventory-transactions/${transactionId}/red-flush`,
    method: 'post',
    data,
    timeout: 60000
  })
}

/**
 * 获取库存交易类型列表
 * @param {Object} params - 查询参数
 * @returns {Promise}
 */
export const getInventoryTransactionTypes = (params) => {
  return request({
    url: '/api/inventory-transaction-types',
    method: 'get',
    params
  })
}
/**
 * 获取当前最大的仓库手动编码
 * @returns {Promise}
 */
export const getMaxWarehouseCode = () => {
  return request({
    url: '/api/inventory-transactions/max-warehouse-code',
    method: 'get'
  })
}

/**
 * 清除所有库存交易记录并重置库存数据
 * @param {boolean} confirm - 确认参数
 * @returns {Promise}
 */
export const clearAllTransactions = (confirm = true, operationPassword) => {
  return request({
    url: '/api/inventory-transactions/clear-all',
    method: 'delete',
    params: { confirm: confirm.toString() },
    headers: operationPassword
      ? { 'X-Operation-Password': operationPassword }
      : undefined,
  })
}

/**
 * 下载期初入库Excel模板
 * @returns {Promise}
 */
export const downloadInitialStockTemplate = () => {
  return request({
    url: '/api/inventory-transactions/initial-stock-template',
    method: 'get',
    responseType: 'blob'
  })
}

/**
 * 解析期初入库Excel文件
 * @param {File} file - Excel文件
 * @returns {Promise}
 */
export const parseInitialStockExcel = (file) => {
  const formData = new FormData()
  formData.append('file', file)
  return request({
    url: '/api/inventory-transactions/parse-initial-stock-excel',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    timeout: 300000 // 大文件解析可能较慢
  })
}

/**
 * 批量导入期初入库
 * @param {Object} data - 批量导入数据
 * @returns {Promise}
 */
export const batchImportInitialStock = (data) => {
  return request({
    url: '/api/inventory-transactions/batch-import-initial-stock',
    method: 'post',
    data,
    timeout: 180000 // 分批上传时每批最多 3 分钟
  })
}
